import { useEffect, useState } from "react";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import usePaginator from "../../../../theme/Component/usePaginator";
import { toast } from "react-toastify";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import { BasicButton } from "../../../../theme/Component/BasicButton";
import { BasicPage } from "../../../../theme/Component/BasicPage";
import { BasicTable } from "../../../../theme/Component/BasicTable";
import { Modal } from "../../../../theme/Component/Modal";
import { ModalConfirm } from "../../../../theme/Component/ModalConfirm";
import { _ClinicalDocument, _HealthScope, _MeansAdministration, _PharmaCumState, _PharmaRecordState } from "../../../../../core/services/dataBean/EntityCatalogVdos";
import { AccountEditor } from "../../../../editor/AccountEditor";
import { AccountantYear } from "../../../GestionTH/EmployeeContract/ProductionPlan/AccountantYear";
import { MonthEditorbyconst } from "../../../../RemoteAbstractAction/editors/MonthEditorbyconst";
import { ClinicalDocumentType } from "./ClinicalDocumentType";
import { ClinicalDocumentState } from "./ClinicalDocumentState";
import { InputDate } from "../../../../theme/Input/InputDate";
import { HealthAttentionModalityEditor } from "../../../../GestionTerceros/AbstractAccount/HealthAttentionModality/HealthAttentionModalityEditor";
import { HealthAttentionServiceEditor } from "../../../../GestionTerceros/AbstractAccount/HealthAttentionService/HealthAttentionServiceEditor";
import { HealthAttentionSiteEditor } from "../../../../GestionTerceros/AbstractAccount/HealthAttentionSite/HealthAttentionSiteEditor";
import { HealthAttentionGateEntryEditor } from "../../../../GestionTerceros/AbstractAccount/HealthAttentionGateEntry/HealthAttentionGateEntryEditor";
import { HealthAttentionCauseEditor } from "../../../../GestionTerceros/AbstractAccount/HealthAttentionCause/HealthAttentionCauseEditor";
import { TriageTypeEditor } from "../../../../GestionTerceros/AbstractAccount/TriageType/TriageTypeEditor";
import { RiskFactoryTypeEditor } from "../../../../GestionTerceros/AbstractAccount/RiskType/RiskFactoryTypeEditor";
import { HealthAllergiesEditor } from "../../../../GestionTerceros/AbstractAccount/HealthAllergies/HealthAllergiesEditor";
import { PatientDischargeStatusEditor } from "../../../../GestionTerceros/AbstractAccount/PatientDischargeStatus/PatientDischargeStatusEditor";
import { HealthIDEditor } from "../../../../admin/configuracion/HealthID/HealthIDEditor";
import { HealthOrphanDiseaseEditor } from "../../../../GestionTerceros/AbstractAccount/HealthOrphanDisease/HealthOrphanDiseaseEditor";
import { HealthDiagnosisTypeEditor } from "../../../../GestionTerceros/AbstractAccount/HealthDiagnosisType/HealthDiagnosisTypeEditor";
import { HealthServiceProvision } from "./HealthServiceProvision";
import { DiagnosisHelp } from "./DiagnosisHelp";
import { ClinicalDocumentEvent } from "./ClinicalDocumentEvent";
import { HealthRegimenEditor } from "../../../../GestionTerceros/AbstractAccount/HealthRegimen/HealthRegimenEditor";
import { WelfareEntityEditorTable } from "../../../WelfareEntity/WelfareEntityEditorTable";
import { CountriesEditor } from "../../../../Inventories-Warehouses/Product/Countries/CountriesEditor";
import { CitiesEditor } from "../../../../Inventories-Warehouses/Product/Countries/Cities/CitiesEditor";
import { SiteTypeEditor } from "../../../../Inventories-Warehouses/Product/SiteType/SiteTypeEditor";
import { DocTypeConstantsEditor } from "../../../../GestionTerceros/AbstractAccount/Editor/DocTypeConstants.editor";
import { GenderTypeConstantsEditor } from "../../../../GestionTerceros/AbstractAccount/Editor/GenderTypeConstants.editor";
import { SexTypeEditor } from "../../SexType/SexTypeEditor";
import { BasicSwitch } from "../../../../theme/Component/BasicSwitch";
import { EthnicGroupEditor } from "../../EthnicGroup/EthnicGroupEditor";
import { PopulationTypeEditor } from "../../PopulationType/PopulationTypeEditor";
import { HealthDisabilityTypeEditor } from "../../../../Inventories-Warehouses/Product/HealthDisabilityType/HealthDisabilityTypeEditor";
import { _single } from "../../../../../core/services/dataBean/EntityCatalog";

import "./ClinicalDocument.css";
import { SelectorHealthEntryPointTypeConstants } from "./Components/SelectorHealthEntryPointTypeConstants";
import useModal, { MODAL_md } from "../../../../theme/Component/hooks/useModal";

export const ClinicalDocument = () => {

    const { instance, bean, setBean, lista, setLista, update, handleChange, validateForm, isMissing, isRequired, addRequiredFields } = useDataBean(_ClinicalDocument);
    const paginador = usePaginator();
    const [State, setState] = useState<any>(null)
    const [form, setForm] = useState<any>({
        IDHealthAttentionModality: null,
        HealthAttentionModalityName: null,
        IDHealthAttentionService: null,
        HealthAttentionServiceName: null,
        IDHealthAttentionSite: null,
        HealthAttentionSiteName: null,
        IDHealthAttentionGateEntry: null,
        HealthAttentionGateEntryName: null,
        IDHealthAttentionCause: null,
        HealthAttentionCauseName: null,
        IDTriageType: null,
        TriageTypeName: null,
        IDPatientDischargeStatus: null,
        PatientDischargeStatusName: null,
        IDHealthAllergies: null,
        HealthAllergiesName: null,
        IDRiskFactoryType: null,
        RiskFactoryTypeName: null,

    })
    const [nit, setNit] = useState<any>(null);
    const [Surname1, setSurname1] = useState<any>(null);
    const [Surname2, setSurname2] = useState<any>(null);
    const [Name1, setName1] = useState<any>(null);
    const [Name2, setName2] = useState<any>(null);
    const [NameSelect, setNameSelect] = useState<any>(null);
    const [type, settype] = useState<any>(null)
    const [Year, setYear] = useState<any>(_single.getCurrenYear())
    const [Month, setMonth] = useState<any>(_single.getCurrentMonth())
    const [response, setResponse] = useState<Record<string, any>>({});

    const [Account, setAccount] = useState<number>(null)
    const [entryPointType, setEntryPointType] = useState<number>(null)
    const [modaldiag, setModaldiag] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalsoporte, setModalsoporte] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalsalud, setModalsalud] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-xl' });
    const [modalevent, setModalevent] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalregist, setModalregist] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modaldemo, setModaldemo] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalcreate, setModalcreate] = useState<any>({ tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: "Eliminar", tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-sm' });
    const modalAdmit = useModal("Admitir Paciente", MODAL_md);

    useEffect(() => {
        getLista();
    }, [paginador.page])

    useEffect(() => {
        addRequiredFields([
            "IDHealthRegimen",
            "IDCountriesNationality",
            "IDCitiesResidence",
            "DocType",
            "BornDate",
            "GenType",
            "IDLnCIUO88",
            "IDHealthDisabilityType",
            ...(bean.IsNonOrganDonor === true ? ["NonOrganDonorDate"] : [])
        ]);
    }, [bean.IsNonOrganDonor])

    const getLista = () => {

        instance.getClinicalDocumentCatalog(entryPointType, Account, type, Year, Month, State, form.IDHealthAttentionModality, form.IDHealthAttentionService, form.IDHealthAttentionSite,
            form.IDHealthAttentionGateEntry, form.IDHealthAttentionCause, form.IDTriageType, form.IDPatientDischargeStatus, form.IDHealthAllergies, form.IDRiskFactoryType, paginador.page, 15).then(
                (resp: any) => {
                    if (resp) {
                        paginador.setPages(resp.NumberOfPages);
                        paginador.setRecords(resp.NumberOfPages * (15));
                        paginador.setRegiPerPage(15)
                        // setLista(resp.List)
                        let x = resp.List;
                        x.forEach((user) => {
                            user.DataBeanProperties.Pacient = (user.DataBeanProperties.Nit ?? "") + "-" + (user.DataBeanProperties.Surname1 ?? "")
                                + "-" + (user.DataBeanProperties.Surname2 ?? "") + "-" + (user.DataBeanProperties.Name1 ?? "") + "-" + (user.DataBeanProperties.Name1 ?? "");
                            user.DataBeanProperties.health = (user.DataBeanProperties.AccountSupplierNit ?? "") + "-" + (user.DataBeanProperties.AccountSupplierName ?? "");
                            user.DataBeanProperties.ModAtt = (user.DataBeanProperties.HealthAttentionModalityCode ?? "") + "-" + (user.DataBeanProperties.HealthAttentionModalityName ?? "");
                            user.DataBeanProperties.HealthAtt = (user.DataBeanProperties.HealthAttentionServiceCode ?? "") + "-" + (user.DataBeanProperties.HealthAttentionServiceName ?? "");
                            user.DataBeanProperties.HealtSite = (user.DataBeanProperties.HealthAttentionSiteCode ?? "") + "-" + (user.DataBeanProperties.HealthAttentionSiteName ?? "");
                            user.DataBeanProperties.HeaEntry = (user.DataBeanProperties.HealthAttentionGateEntryCode ?? "") + "-" + (user.DataBeanProperties.HealthAttentionGateEntryName ?? "");
                            user.DataBeanProperties.HealthCause = (user.DataBeanProperties.HealthAttentionCauseCode ?? "") + "-" + (user.DataBeanProperties.HealthAttentionCauseName ?? "");
                            user.DataBeanProperties.Triage = (user.DataBeanProperties.TriageTypeCode ?? "") + "-" + (user.DataBeanProperties.TriageTypeName ?? "");
                            user.DataBeanProperties.Diagp = (user.DataBeanProperties.HealthIDJsonCode ?? "") + "-" + (user.DataBeanProperties.HealthIDName ?? "");
                            user.DataBeanProperties.Enfh = (user.DataBeanProperties.HealthOrphanDiseaseCode ?? "") + "-" + (user.DataBeanProperties.HealthOrphanDiseaseName ?? "");
                            user.DataBeanProperties.DiagType = (user.DataBeanProperties.HealthDiagnosisTypeCode ?? "") + "-" + (user.DataBeanProperties.HealthDiagnosisTypeName ?? "");
                            user.DataBeanProperties.PatientStatus = (user.DataBeanProperties.PatientDischargeStatusCode ?? "") + "-" + (user.DataBeanProperties.PatientDischargeStatusName ?? "");
                            user.DataBeanProperties.HealthAll = (user.DataBeanProperties.HealthAllergiesCode ?? "") + "-" + (user.DataBeanProperties.HealthAllergiesName ?? "");
                            user.DataBeanProperties.RiskFacType = (user.DataBeanProperties.RiskFactoryTypeCode ?? "") + "-" + (user.DataBeanProperties.RiskFactoryTypeName ?? "");
                        });
                        setLista(x)
                    }
                }
            )

    }

    const create = () => {
        setBean({});
        setModalcreate({ ...modalcreate, "view": true });
    }

    const deleteItem = () => {
        instance.deleteVoid(bean.IDHealthScope).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "view": false });
            }
        )

    }

    const editaItem = () => {
        update().then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const createClinicalDocument = () => {

        instance.createClinicalDocument(bean.IDAccount, null, _single.getAccountID()).then(
            (resp: any) => {
                console.log(resp.Nit)
                getLista();
                setBean({
                    ...bean,
                    ...resp
                });
                setNit(resp.Nit)
                setSurname1(resp.Surname1)
                setSurname2(resp.Surname2)
                setName1(resp.Name1)
                setName2(resp.Name2)
                setModalcreate({ ...modalcreate, "view": false });
                setModaldemo({ ...modaldemo, "view": true });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const validateDemographicDataClinicalDocument = () => {
        if (!validateForm()) {
            toast.error("Faltan Campos Obligatorios por diligenciar");
            return;
        }
        instance.validateDemographicDataClinicalDocument(bean, _single.getAccountID()).then(
            (resp: any) => {
                console.log(resp)
                getLista();
                setModaldemo({ ...modaldemo, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const admitClinicalDocument = () => {

        instance.admitClinicalDocument(bean.IDClinicalDocument, bean.IssueDate, response.HealthEntryPointType, _single.getAccountID()).then(
            (resp: any) => {
                console.log(resp)
                modalAdmit.close();
                getLista();
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const doTriageToClinicalDocument = () => {

        instance.doTriageToClinicalDocument(bean.IDClinicalDocument, bean.IssueDate, bean.IDTriageType, bean.TriageDate, _single.getAccountID()).then(
            (resp: any) => {
                console.log(resp)
                getLista();
                setModalregist({ ...modalregist, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }
    const head = [
        { title: 'ID', property: 'IDClinicalDocument', visible: true },
        { title: 'Estado', property: 'StateName', visible: true },
        { title: 'Fecha Evento', property: 'IssueDate', visible: true },
        { title: 'Paciente', property: 'Pacient', visible: true },
        { title: 'Triage', property: 'Triage', visible: true },
        { title: 'Prestador de Salud', property: 'health', visible: true },
        { title: 'Descripción', property: 'Description', visible: true },
        { title: 'Fecha Inicio Evento', property: 'InitDate', visible: true },
        { title: 'Hora Inicio Evento', property: 'InitTime', visible: true },
        { title: 'Fecha Final Evento', property: 'UptoDate', visible: true },
        { title: 'Hora Final Evento', property: 'UptoTime', visible: true },
        { title: 'Estado de Salida del Paciente', property: 'PatientStatus', visible: true },
        { title: 'Tipo', property: 'TypeName', visible: true },
        { title: 'Número de Evento', property: 'EventNumber', visible: true },
        { title: 'Modalidad de Atención', property: 'ModAtt', visible: true },
        { title: 'Tipo de Servicio', property: 'HealthAtt', visible: true },
        { title: 'Sitio de Atención', property: 'HealtSite', visible: true },
        { title: 'Puerta de Entrada de Atención', property: 'HeaEntry', visible: true },
        { title: 'Causa de Atención', property: 'HealthCause', visible: true },
        { title: 'Fecha Toma Triage', property: 'TriageDate', visible: true },
        { title: 'Hora Toma Triage', property: 'TriageTime', visible: true },
        { title: 'Diagnóstico Principal', property: 'Diagp', visible: true },
        { title: 'Enfermedad Huerfana', property: 'Enfh', visible: true },
        { title: 'Tipo de Diagnóstico', property: 'DiagType', visible: true },
        { title: 'Alergias', property: 'HealthAll', visible: true },
        { title: 'Factor de Riesgo', property: 'RiskFacType', visible: true },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-edit-2-line', visible: _single.canEdit(), evento: () => { setModal({ ...modal, "view": true }) } },
            { titulo: 'Editar Información Demográfica', icono: 'ri-send-plane-2-line', visible: _single.canEdit(), evento: () => { setModaldemo({ ...modaldemo, "view": true }) } },
            { titulo: 'Admitir Paciente', icono: 'ri-user-shared-line', visible: _single.canEdit(), evento: () => { modalAdmit.open(); setResponse({}); } },
            { titulo: 'Registrar Triage', icono: 'ri-align-left', visible: _single.canEdit(), evento: () => { setModalregist({ ...modalregist, "view": true }) } },
            { titulo: 'Soportes de Pago', icono: 'ri-secure-payment-fill', visible: _single.canEdit(), evento: () => { setModalsoporte({ ...modalsoporte, "view": true }) } },
            { titulo: 'Tecnologías en Salud', icono: 'ri-home-heart-line', visible: _single.canEdit(), evento: () => { setModalsalud({ ...modalsalud, "view": true }) } },
            { titulo: 'Ayudas Diagnósticas', icono: 'bx bx-help-circle', visible: _single.canEdit(), evento: () => { setModaldiag({ ...modaldiag, "view": true }) } },
            { titulo: 'Eventos', icono: 'ri-calendar-event-line', visible: _single.canEdit(), evento: () => { setModalevent({ ...modalevent, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: _single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }
    return (
        <BasicPage titulo="Historia Clínica">
            <div className="row">
                <div className="col-md-4">
                    <SelectorHealthEntryPointTypeConstants idSelector={entryPointType} onChange={(e) => { setEntryPointType(e) }} />
                </div>
                <div className="col-md-4">
                    <AccountEditor idAccount={Account} onChange={(e) => { setAccount(e.IDAccount) }} label="Paciente" />
                </div>
                <div className="col-md-4">
                    <AccountantYear idSelector={Year} onChange={(e) => { setYear(e) }} />
                </div>
                <div className="col-md-4">
                    <MonthEditorbyconst idSelector={Month} onChange={(e) => { setMonth(e) }} />
                </div>
                <div className="col-md-4">
                    <ClinicalDocumentType idSelector={type} onChange={(e) => { settype(e) }} />
                </div>
                <div className="col-md-4">
                    <ClinicalDocumentState idSelector={State} onChange={(e) => { setState(e) }} />
                </div>
                <div className="col-md-4">
                    <HealthAttentionModalityEditor render={form.HealthAttentionModalityName} idSelector={form.IDHealthAttentionModality} onChange={(e) => { setForm({ ...form, "IDHealthAttentionModality": e.IDHealthAttentionModality, "HealthAttentionModalityName": e.Name }) }} returnType="Object" />
                </div>
                <div className="col-md-4">
                    <HealthAttentionServiceEditor render={form.HealthAttentionServiceName} idSelector={form.IDHealthAttentionService} onChange={(e) => { setForm({ ...form, "IDHealthAttentionService": e.IDHealthAttentionService, "HealthAttentionServiceName": e.Name }) }} returnType="Object" />
                </div>
                <div className="col-md-4">
                    <HealthAttentionSiteEditor render={form.HealthAttentionSiteName} idSelector={form.IDHealthAttentionSite} onChange={(e) => { setForm({ ...form, "IDHealthAttentionSite": e.IDHealthAttentionSite, "HealthAttentionSiteName": e.Name }) }} returnType="Object" />
                </div>
                <div className="col-md-4">
                    <HealthAttentionGateEntryEditor render={form.HealthAttentionGateEntryName} idSelector={form.IDHealthAttentionGateEntry} onChange={(e) => { setForm({ ...form, "IDHealthAttentionGateEntry": e.IDHealthAttentionGateEntry, "HealthAttentionGateEntryName": e.Name }) }} returnType="Object" />
                </div>
                <div className="col-md-4">
                    <HealthAttentionCauseEditor render={form.HealthAttentionCauseName} idSelector={form.IDHealthAttentionCause} onChange={(e) => { setForm({ ...form, "IDHealthAttentionCause": e.IDHealthAttentionCause, "HealthAttentionCauseName": e.Name }) }} returnType="Object" />
                </div>
                <div className="col-md-4">
                    <TriageTypeEditor render={form.TriageTypeName} idSelector={form.IDTriageType} onChange={(e) => { setForm({ ...form, "IDTriageType": e.IDTriageType, "TriageTypeName": e.Name }) }} returnType="Object" />
                </div>
                <div className="col-md-4">
                    <PatientDischargeStatusEditor render={form.PatientDischargeStatusName} idSelector={form.IDPatientDischargeStatus} onChange={(e) => { setForm({ ...form, "IDPatientDischargeStatus": e.IDPatientDischargeStatus, "PatientDischargeStatusName": e.Name }) }} returnType="Object" />
                </div>
                <div className="col-md-4">
                    <HealthAllergiesEditor render={form.HealthAllergiesName} idSelector={form.IDHealthAllergies} onChange={(e) => { setForm({ ...form, "IDHealthAllergies": e.IDHealthAllergies, "HealthAllergiesName": e.Name }) }} returnType="Object" />
                </div>
                <div className="col-md-4">
                    <RiskFactoryTypeEditor render={form.RiskFactoryTypeName} idSelector={form.IDRiskFactoryType} onChange={(e) => { setForm({ ...form, "IDRiskFactoryType": e.IDRiskFactoryType, "RiskFactoryTypeName": e.Name }) }} returnType="Object" />
                </div>
                <div className="col-md-6 mt-4 p-2">
                    <BasicButton icon="ri-align-justify" eventClick={getLista}>Buscar</BasicButton>
                </div>

                <div className="col-md-12">

                    <BasicTable body={lista} head={head} rowSet={setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem} pageTop={paginador.page} next={paginador.next} back={paginador.back} records={paginador} customRows={15}></BasicTable>

                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">
                            <div className="col-md-12">
                                {bean.Nit}-{bean.Surname1}-{bean.Surname2}-{bean.Name1}-{bean.Name2}
                            </div>
                            <div className="col-md-6">
                                <InputDate name="IssueDate" label="Fecha Evento" value={bean.IssueDate} setDate={(e: any) => { setBean({ ...bean, "IssueDate": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <ClinicalDocumentType idSelector={bean.Type} onChange={(e: any) => { setBean({ ...bean, "Type": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <AccountEditor idAccount={bean.IDAccount} onChange={(e: any) => { setBean({ ...bean, "IDAccount": e.IDAccount }) }} label="Paciente" />
                            </div>
                            <div className="col-md-6">
                                <AccountEditor idAccount={bean.IDAccountSupplier} onChange={(e: any) => { setBean({ ...bean, "IDAccountSupplier": e.IDAccount }) }} label="Prestador de Salud" />
                            </div>
                            <div className="col-md-6">
                                <InputDate name="InitDate" label="Fecha inicio Evento" value={bean.InitDate} setDate={(e: any) => { setBean({ ...bean, "InitDate": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Hora Inicio Evento</label>
                                <input type="text" name="InitTime" className="form-control" value={bean.InitTime} onChange={(e: any) => { setBean({ ...bean, 'InitTime': e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <InputDate name="UptoDate" label="Fecha final Evento" value={bean.UptoDate} setDate={(e: any) => { setBean({ ...bean, "UptoDate": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Hora Final Evento</label>
                                <input type="text" name="UptoTime" className="form-control" value={bean.UptoTime} onChange={(e: any) => { setBean({ ...bean, 'UptoTime': e.target.value }) }} />
                            </div>
                            <div className="col-md-6">
                                <HealthAttentionModalityEditor render={bean.HealthAttentionModalityName} idSelector={bean.IDHealthAttentionModality} onChange={(e) => { setBean({ ...bean, "IDHealthAttentionModality": e.IDHealthAttentionModality, "HealthAttentionModalityName": e.Name }) }} returnType="Object" />
                            </div>
                            <div className="col-md-6">
                                <HealthAttentionServiceEditor render={bean.HealthAttentionServiceName} idSelector={bean.IDHealthAttentionService} onChange={(e) => { setBean({ ...bean, "IDHealthAttentionService": e.IDHealthAttentionService, "HealthAttentionServiceName": e.Name }) }} returnType="Object" />
                            </div>
                            <div className="col-md-6">
                                <HealthAttentionSiteEditor render={bean.HealthAttentionSiteName} idSelector={bean.IDHealthAttentionSite} onChange={(e) => { setBean({ ...bean, "IDHealthAttentionSite": e.IDHealthAttentionSite, "HealthAttentionSiteName": e.Name }) }} returnType="Object" />
                            </div>
                            <div className="col-md-6">
                                <HealthAttentionGateEntryEditor render={bean.HealthAttentionGateEntryName} idSelector={bean.IDHealthAttentionGateEntry} onChange={(e) => { setBean({ ...bean, "IDHealthAttentionGateEntry": e.IDHealthAttentionGateEntry, "HealthAttentionGateEntryName": e.Name }) }} returnType="Object" />
                            </div>
                            <div className="col-md-6">
                                <HealthAttentionCauseEditor render={bean.HealthAttentionCauseName} idSelector={bean.IDHealthAttentionCause} onChange={(e) => { setBean({ ...bean, "IDHealthAttentionCause": e.IDHealthAttentionCause, "HealthAttentionCauseName": e.Name }) }} returnType="Object" />
                            </div>
                            <div className="col-md-6">
                                <TriageTypeEditor render={bean.TriageTypeName} idSelector={bean.IDTriageType} onChange={(e) => { setBean({ ...bean, "IDTriageType": e.IDTriageType, "TriageTypeName": e.Name }) }} returnType="Object" />
                            </div>
                            <div className="col-md-6">
                                <InputDate name="TriageDate" label="Fecha Toma Triage" value={bean.TriageDate} setDate={(e: any) => { setBean({ ...bean, "TriageDate": e }) }} />
                            </div>
                            <div className="col-md-6">
                                <label>Hora Toma Triage</label>
                                <input type="text" name="TriageTime" className="form-control" value={bean.TriageTime} onChange={(e: any) => { setBean({ ...bean, 'TriageTime': e.target.value }) }} />
                            </div>
                            <div className="col-md-12">
                                <HealthIDEditor tipoPresupuesto={30} render={bean.HealthIDName || NameSelect} id={null} edit={true} onSelect={(e) => { setBean({ ...bean, "IDLnCIE": e }) }} onSelectName={(item) => { console.log(item); setNameSelect(item); }} />
                            </div>
                            <div className="col-md-6">
                                <HealthOrphanDiseaseEditor render={bean.HealthOrphanDiseaseName} idSelector={bean.IDHealthOrphanDisease} onChange={(e) => { setBean({ ...bean, "IDHealthOrphanDisease": e.IDHealthOrphanDisease, "HealthOrphanDiseaseName": e.Name }) }} returnType="Object" />
                            </div>
                            <div className="col-md-6">
                                <HealthDiagnosisTypeEditor render={bean.HealthDiagnosisTypeName} idSelector={bean.IDHealthDiagnosisType} onChange={(e) => { setBean({ ...bean, "IDHealthDiagnosisType": e.IDHealthDiagnosisType, "HealthDiagnosisTypeName": e.Name }) }} returnType="Object" />
                            </div>
                            <div className="col-md-6">
                                <PatientDischargeStatusEditor render={bean.PatientDischargeStatusName} idSelector={bean.IDPatientDischargeStatus} onChange={(e) => { setBean({ ...bean, "IDPatientDischargeStatus": e.IDPatientDischargeStatus, "PatientDischargeStatusName": e.Name }) }} returnType="Object" />
                            </div>
                            <div className="col-md-6">
                                <HealthAllergiesEditor render={bean.HealthAllergiesName} idSelector={bean.IDHealthAllergies} onChange={(e) => { setBean({ ...bean, "IDHealthAllergies": e.IDHealthAllergies, "HealthAllergiesName": e.Name }) }} returnType="Object" />
                            </div>
                            <div className="col-md-6">
                                <RiskFactoryTypeEditor render={bean.RiskFactoryTypeName} idSelector={bean.IDRiskFactoryType} onChange={(e) => { setBean({ ...bean, "IDRiskFactoryType": e.IDRiskFactoryType, "RiskFactoryTypeName": e.Name }) }} returnType="Object" />
                            </div>
                            <div className="col-md-12">
                                <label>Descripción</label>
                                <textarea name="Description" className="form-control" value={bean.Description} onChange={handleChange} />
                            </div>
                        </div>
                    </Modal>

                    <Modal modal={modalcreate} updateModal={setModalcreate} eventModal={createClinicalDocument}>
                        <div className="row">
                            <div className="col-md-12">
                                <label>Creación de la Historia Clinica</label>
                            </div>
                            <div className="col-md-12">
                                <AccountEditor idAccount={bean.IDAccount} onChange={(e) => { setBean({ ...bean, "IDAccount": e.IDAccount }) }} label="Paciente" />
                            </div>
                        </div>
                    </Modal>

                    <Modal modal={modaldemo} updateModal={setModaldemo} eventModal={validateDemographicDataClinicalDocument}>
                        <div className="clinical-form">

                            {/* PACIENTE */}
                            <div className="patient-summary mb-3">
                                <span className="patient-summary__label">
                                    <i className="ri-user-line"></i> Paciente
                                </span>

                                <strong>
                                    {bean.Nit
                                        ? `${bean.Nit} - ${bean.Surname1 || ""} ${bean.Surname2 || ""} ${bean.Name1 || ""} ${bean.Name2 || ""}`
                                        : nit && `${nit} - ${Surname1 || ""} ${Surname2 || ""} ${Name1 || ""} ${Name2 || ""}`
                                    }
                                </strong>
                            </div>

                            {/* INFORMACIÓN GENERAL */}
                            <section className="clinical-section mb-3">
                                <div className="clinical-section__header">
                                    <i className="ri-profile-line"></i>
                                    Información general del paciente
                                </div>

                                <div className="clinical-section__body">
                                    <div className="row g-3">

                                        <div className="col-md-6">
                                            <label className={`${isMissing('IDHealthRegimen') ? 'has-error' : ''}`}>Régimen de salud {isRequired('IDHealthRegimen') ? <span className="text-danger">*</span> : ''}</label>
                                            <HealthRegimenEditor label=" " render={bean.HealthRegimenName} idSelector={bean.IDHealthRegimen} onChange={(e) => { setBean({ ...bean, IDHealthRegimen: e.IDHealthRegimen, HealthRegimenName: e.Name }); }} returnType="Object" />
                                        </div>

                                        <div className="col-md-6">
                                            <WelfareEntityEditorTable
                                                label="Entidad Responsable por el Plan de Beneficios de Salud"
                                                render={bean.WelfareEntityName}
                                                idSelector={bean.IDHealthWelfareEntity}
                                                onChange={(e) => { setBean({ ...bean, IDHealthWelfareEntity: e.IDWelfareEntity, WelfareEntityName: e.AccountName }); }}
                                                returnType="Object"
                                            />
                                        </div>

                                        <div className="col-md-4">
                                            <label className={`${isMissing('DocType') ? 'has-error' : ''}`}>Tipo de documento {isRequired('DocType') ? <span className="text-danger">*</span> : ''}</label>
                                            <DocTypeConstantsEditor
                                                label=" "
                                                idSelector={bean.DocType}
                                                onChange={(e) => {
                                                    setBean({ ...bean, DocType: e });
                                                }}
                                            />
                                        </div>

                                        <div className="col-md-4">
                                            <label className={`${isMissing('BornDate') ? 'has-error' : ''}`}>Fecha de nacimiento {isRequired('BornDate') ? <span className="text-danger">*</span> : ''}</label>
                                            <InputDate
                                                label=" "
                                                name="Fecha Nacimiento"
                                                value={bean.BornDate}
                                                setDate={(e) => { setBean({ ...bean, BornDate: e }); }}
                                            />
                                        </div>

                                        <div className="col-md-4">
                                            <label className={`${isMissing('GenType') ? 'has-error' : ''}`}>Sexo biológico {isRequired('GenType') ? <span className="text-danger">*</span> : ''}</label>
                                            <GenderTypeConstantsEditor
                                                label=" "
                                                idSelector={bean.GenType}
                                                onChange={(e) => { setBean({ ...bean, GenType: e }); }}
                                            />
                                        </div>

                                        <div className="col-md-6">
                                            <SexTypeEditor
                                                render={bean.SexTypeName}
                                                idSelector={bean.IDSexType}
                                                onChange={(e) => { setBean({ ...bean, IDSexType: e.IDSexType, SexTypeName: e.Name }); }}
                                                returnType="Object"
                                            />
                                        </div>

                                        <div className="col-md-6">
                                            <label className={`${isMissing('IDCountriesNationality') ? 'has-error' : ''}`}>País de nacionalidad {isRequired('IDCountriesNationality') ? <span className="text-danger">*</span> : ''}</label>
                                            <CountriesEditor

                                                render={bean.CountriesNationalityName}
                                                idSelector={bean.IDCountriesNationality}
                                                onChange={(e) => { setBean({ ...bean, IDCountriesNationality: e.IDCountries, CountriesNationalityName: e.Name }); }}
                                                label=" "
                                                returnType="Object"
                                            />
                                        </div>

                                        <div className="col-md-6">
                                            <label className={`${isMissing('IDCitiesResidence') ? 'has-error' : ''}`}>Ciudad de residencia {isRequired('IDCitiesResidence') ? <span className="text-danger">*</span> : ''}</label>
                                            <CitiesEditor
                                                render={bean.CitiesResidenceName}
                                                idSelector={bean.IDCitiesResidence}
                                                onChange={(e) => { setBean({ ...bean, IDCitiesResidence: e.IDCities, CitiesResidenceName: e.Name }); }}
                                                label=" "
                                                returnType="Object"
                                            />
                                        </div>

                                        <div className="col-md-6">
                                            <SiteTypeEditor
                                                render={bean.ResidenceSiteTypeName}
                                                idSelector={bean.IDResidenceSiteType}
                                                onChange={(e) => { setBean({ ...bean, IDResidenceSiteType: e.IDSiteType, ResidenceSiteTypeName: e.Name }); }}
                                                label="Zona territorial de residencia"
                                                returnType="Object"
                                            />
                                        </div>

                                        <div className="col-md-6">
                                            <label className={`${isMissing('IDHealthDisabilityType') ? 'has-error' : ''}`}>Tipo de discapacidad {isRequired('IDHealthDisabilityType') ? <span className="text-danger">*</span> : ''}</label>
                                            <HealthDisabilityTypeEditor
                                                label=" "
                                                render={bean.HealthDisabilityTypeName}
                                                idSelector={bean.IDHealthDisabilityType}
                                                onChange={(e) => { setBean({ ...bean, IDHealthDisabilityType: e.IDHealthDisabilityType, HealthDisabilityTypeName: e.Name }); }}
                                                returnType="Object"
                                            />
                                        </div>

                                        <div className="col-md-6">
                                            <EthnicGroupEditor
                                                render={bean.EthnicGroupName}
                                                idSelector={bean.IDEthnicGroup}
                                                onChange={(e) => { setBean({ ...bean, IDEthnicGroup: e.IDEthnicGroup, EthnicGroupName: e.Name }); }}
                                                label="Pertenencia étnica"
                                                returnType="Object"
                                            />
                                        </div>

                                        <div className="col-md-6">
                                            <PopulationTypeEditor
                                                render={bean.PopulationTypeName}
                                                idSelector={bean.IDPopulationType}
                                                onChange={(e) => { setBean({ ...bean, IDPopulationType: e.IDPopulationType, PopulationTypeName: e.Name }); }}
                                                label="Comunidad étnica" returnType="Object"
                                            />
                                        </div>

                                        <div className="col-12">
                                            <label className={`${isMissing('IDLnCIUO88') ? 'has-error' : ''}`}>Ocupación {isRequired('IDLnCIUO88') ? <span className="text-danger">*</span> : ''}</label>
                                            <HealthIDEditor
                                                label=" "
                                                tipoPresupuesto={29}
                                                render={bean.HealthIDName || NameSelect}
                                                id={null}
                                                edit={true}
                                                onSelect={(e) => { setBean({ ...bean, IDLnCIUO88: e }); }}
                                                onSelectName={(item) => { setNameSelect(item); }}
                                            />
                                        </div>

                                    </div>
                                </div>
                            </section>

                            {/* CONDICIONES ESPECIALES */}
                            <section className="clinical-section">
                                <div className="clinical-section__header">
                                    <i className="ri-heart-pulse-line"></i>
                                    Condiciones especiales y voluntades
                                </div>

                                <div className="clinical-section__body">
                                    <div className="row g-3">
                                        <div className="col-12">
                                            <div className="clinical-switch-box">
                                                <label className={`${isMissing('IsNonOrganDonor') ? 'has-error' : ''}`}>Oposición a la presunción legal de donación {isRequired('IsNonOrganDonor') ? <span className="text-danger">*</span> : ''}</label>
                                                <BasicSwitch label=" " estado={bean.IsNonOrganDonor} eventChange={(e) => { setBean({ ...bean, IsNonOrganDonor: e }); }} />
                                                <small>
                                                    Expresión de la voluntad de no ser donante de órganos y tejidos, mediante un documento escrito. (Ley 1805 de 2016 o normatividad vigente)
                                                </small>
                                            </div>
                                        </div>

                                        {bean.IsNonOrganDonor && (
                                            <div className="col-md-6">
                                                <label className={`${isMissing('NonOrganDonorDate') ? 'has-error' : ''}`}>Fecha de expresión {isRequired('NonOrganDonorDate') ? <span className="text-danger">*</span> : ''}</label>
                                                <InputDate label=" " name="NonOrganDonorDate" value={bean.NonOrganDonorDate} setDate={(e) => { setBean({ ...bean, NonOrganDonorDate: e }); }} />
                                            </div>
                                        )}

                                        <div className="col-12">
                                            <div className="clinical-switch-box">
                                                <label className={`${isMissing('RefuseLifePreservingTreatment') ? 'has-error' : ''}`}>Documento de voluntad anticipada {isRequired('RefuseLifePreservingTreatment') ? <span className="text-danger">*</span> : ''}</label>
                                                <BasicSwitch label=" " estado={bean.RefuseLifePreservingTreatment} eventChange={(e) => { setBean({ ...bean, RefuseLifePreservingTreatment: e }); }} />
                                                <small>
                                                    Declara de forma libre, consciente e informada su voluntad
                                                    de no someterse a medios, tratamientos o procedimientos
                                                    médicos innecesarios que pretendan prolongar su vida.
                                                </small>
                                            </div>
                                        </div>

                                        {bean.RefuseLifePreservingTreatment && (
                                            <>
                                                <div className="col-md-6">
                                                    <label> Fecha de suscripción, modificación, sustitución o revocación </label>
                                                    <InputDate
                                                        name="RefuseLifePreservingTreatmentDate"
                                                        value={bean.RefuseLifePreservingTreatmentDate}
                                                        setDate={(e) => { setBean({ ...bean, RefuseLifePreservingTreatmentDate: e }); }}
                                                    />
                                                </div>

                                                <div className="col-md-6">
                                                    <WelfareEntityEditorTable label="Código del Prestador donde se encuentra el documento de la voluntad anticipada" render={bean.HealthWelfareEntityRefuseName} idSelector={bean.IDHealthWelfareEntityRefuse} onChange={(e) => { setBean({ ...bean, IDHealthWelfareEntityRefuse: e.IDWelfareEntity, HealthWelfareEntityRefuseName: e.AccountName }); }} returnType="Object" />
                                                </div>
                                            </>
                                        )}

                                    </div>
                                </div>
                            </section>

                        </div>
                    </Modal>

                    <Modal modal={modalregist} updateModal={setModalregist} eventModal={doTriageToClinicalDocument}>
                        <div className="row">
                            <div className="col-md-12">
                                <TriageTypeEditor render={bean.TriageTypeName} idSelector={bean.IDTriageType} onChange={(e) => { setBean({ ...bean, "IDTriageType": e.IDTriageType, "TriageTypeName": e.Name }) }} returnType="Object" />
                            </div>
                            <div className="col-md-12">
                                <label>Fecha Triage</label>
                                <InputDate name='Fecha Nacimiento' value={bean.TriageDate} setDate={(e) => { setBean({ ...bean, "TriageDate": e }) }} />
                            </div>
                        </div>
                    </Modal>

                    <Modal modal={modalsalud} updateModal={setModalsalud}>
                        <HealthServiceProvision idClinicalDocument={bean.IDClinicalDocument} issueDate={bean.IssueDate} />
                    </Modal>

                    <Modal modal={modaldiag} updateModal={setModaldiag}>
                        <DiagnosisHelp idClinicalDocument={bean.IDClinicalDocument} issueDate={bean.IssueDate} />
                    </Modal>

                    <Modal modal={modalAdmit.modal} updateModal={modalAdmit.setModal} eventModal={() => { admitClinicalDocument() }} >
                        <div className="row">
                            <div className="col-md-12">
                                <SelectorHealthEntryPointTypeConstants idSelector={response.HealthEntryPointType} onChange={(e) => { setResponse({ ...response, HealthEntryPointType: e }) }} />
                            </div>
                        </div>
                    </Modal>

                    <Modal modal={modalevent} updateModal={setModalevent}>
                        <ClinicalDocumentEvent idClinicalDocument={bean.IDClinicalDocument} issueDate={bean.IssueDate} />
                    </Modal>

                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item {bean.Name}</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}